<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>Designers and crafters of the world’s exquisite umbrellas.

                    </h1><br>



                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>

<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/lockwood%20umbrella%20logo.jpg?alt=media&token=d91ff080-ce03-4bcc-ae29-c252a51a236f" alt="image" class="ilast-logo">

    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>Lockwood Umbrellas
                    </h2>
                    <p>
                        The Lockwood Umbrellas is an e-commerce business website, that mainly focuses on selling the
                        finest quality umbrellas. Lockwood Umbrellas is from the UK (London).
                        selling premium quality customized and non-customized umbrellas to its customers.

                    </p>
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/james-x-iKjU9yHTEg0-unsplash%20(1).jpg?alt=media&token=88107fb6-5973-4db7-ac6f-25bd211ad629"
                        alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :</span>
                            <h5>8 Members </h5>
                            <h5>
                                Developers | Designers | Project Manager | Quality Analyst
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5>E-commerce & Retail
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 30 Days

                            </h5>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">


                <div class="area">
                    <h4> Who is the Client?</h4>
                    <p class="para">The Lockwood Umbrellas, as the name suggests is a website to purchase umbrellas
                        online.
                        It is an e-commerce website. There are various types of umbrellas available on the website to
                        buy with high durability and quality craftsmanship.
                        The umbrellas are handmade and they believe in crafting an umbrella that lasts forever.

                    </p>
                    <p class="para">
                        The Lockwood Umbrella builts the umbrella using a Grade A steel frame, lathe-turned brass
                        fittings, hand-sewn reinforcements,
                        and proofed water-resistant cloth.The Lockwood Umbrellas make sure that their umbrellas are made
                        up of excellent quality and last for a lifetime.
                    </p>
                </div>
                <div class="area">
                    <h4> Purpose of the Client
                    </h4>
                    <p class="para">The client wanted to revamp the website in WordPress. Initially,
                        the website had a lot of challenges in having its way into the market.
                        The Lockwood Umbrella is a brand selling umbrellas in the UK and wanted to gain a lot of traffic
                        to its website.
                    </p>
                    <P class="para">The Lockwood Umbrellas can deliver custom-made umbrellas whilst working with a fixed
                        budget quota.
                        They offer their customers the benefit that the customers can give the requirements
                        and designs which they wanted to have under their umbrella.

                    </P>


                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4> Challenge
                            </h4>
                            <p class="para text-design">

                                According to the client’s main concern, their website was not getting the expected
                                result they wanted to have.
                            </p>

                            <p class="para text-design">

                                The UI/UX design needed to be changed completely and the features to be implemented that
                                could
                                bring the required engagement and traffic to the website. The development of the website
                                requires a lot of
                                implementation and features to be added.

                            </p>

                        </div>

                    </div>
                </div>
                <!-- <div class="col-md-4">
                    <img src="../../../assets/images/girl.svg.svg" alt="Girl Building">
                </div> -->
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
                <div class="area">
                    <h4> Results</h4>
                    <p class="para">
                        After revamping the website, it has gained many users from around the world
                        and it has been listed among the top websites in the umbrellas niche.

                    </p>

                    <p class="para">
                        Users started getting comfortable using the Lockwood Umbrellas website. Since the website has
                        been rebuilt according to the client's requirements, our team of adroit developers has
                        delivered the product with high-quality services by implementing all the needed features in the
                        website
                    </p>


                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Solution</h4>
                        <p class="para">The team of Vidhema Technologies came up with brilliant
                            features that could be integrated into the website. Our team of dedicated
                            developers revamped the website and added new features to it, it has to be engaging and
                            attractive.
                        </p>
                        <P class="para">
                            The Lockwood Umbrellas website has a section for wholesale buyers,
                            where they design umbrellas for hotels, corporations, and fashion brands.
                        </P>

                        <P class="para">
                            Customers can customize umbrellas for their loved ones
                            if they want to or can easily engrave a name or a phrase if they run a business or a
                            corporation.
                        </P>

                        <ul>
                            <li>
                                Custom Design: The customers can easily customize the design of umbrellas as per their
                                choice and liking. This sounded like a beneficial point for the customers where they can
                                have the umbrellas according to their preferences.
                            </li>

                            <li>
                                Engraving: The customers can also ask to engrave a name or a phrase as they wanted.
                                This could be a great service for the customers if they wanted to gift an umbrella with
                                a name or keep it to themselves.
                            </li>

                            <li>
                                Printing: The Lockwood Umbrellas gives its customers the experience to print the
                                umbrella as per the customer's requirements and designs.

                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Website Features</h4>
                        <p class="para">The payment gateway of Lockwood Umbrellas was Stripe.
                            The Lockwood Umbrellas website features implemented by our team of passionate developers
                            bring a lot of traffic to the website.
                        </p>

                        <ul>
                            <li>
                                Product Listing: The feature was added to the website to make it user-centric and users
                                can easily
                                look out for the options that they are willing to purchase.

                            </li>

                            <li>
                                Social Sharing: With the help of this feature, users and consumers can easily share
                                their favorite
                                umbrella on the social media platform to promote an umbrella and the website as well.

                            </li>

                            <li>
                                Bulk Order: Users can easily purchase umbrellas in bulk and at wholesale prices.
                                This feature is beneficial for retail shoppers to sell umbrellas from their shop outlet
                                in the market.
                            </li>

                            <li>
                                Gift Card: After making a purchase, users will receive a gift card as a reward for their
                                purchase.

                            </li>

                            <li>
                                Product Details: The products will have all the information for the users so that they
                                can easily understand the quality of the product.
                                The details related to the product are helpful for the user as they can easily choose
                                from the options available to them.
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <section class="quote-box" style="    background-color: #0d052a;">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h4>Are You Ready To Discuss Your Project With Us?</h4>
                </div>
                <div class="col-md-3">
                    <button routerLink="/hire-shopify-developers.html">Hire Our Experts</button>
                </div>
            </div>
        </div>
    </section> -->
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-12">
                <div class="case-details-single">


                    <div class="area">
                        <h4>Technologies and Tools </h4>


                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/woocommercelogo.png?alt=media&token=e017dec0-69fa-4d6f-a6a5-f890838d2d6d" alt="image" class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/WordPress-Logo.png?alt=media&token=eb68e3f0-e547-41cd-9de6-05865c7ce12b"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="../../../assets/images/mysql logo.png"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>MySQL</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="../../../assets/images/PHP_logo.png"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Node JS</h5> -->
                                </div>
                            </li>




                        </ul>

                    </div>

                    <div class="container">
                        <div class="row">

                            <div class="area">
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
